import request from "@/utils/request";
import Cookies from "js-cookie";
import ENDPOINT from "@/config/endpoint";

function login(data) {
  return request({
    url: ENDPOINT.LOGIN,
    method: "post",
    data,
  });
}

function updateLoginInfo(data) {
  Cookies.set("login_info", JSON.stringify(data));
}

function loginInfo() {
  try {
    return JSON.parse(Cookies.get("login_info"));
  } catch (_) {
    return null;
  }
}

function logout() {
  Cookies.remove("login_info");
  window.location.reload();
}

export default {
  login,
  updateLoginInfo,
  loginInfo,
  logout,
};
